const S3_BUCKET_URL = "https://toca-sales.s3.us-east-2.amazonaws.com/";

export default S3_BUCKET_URL